// This component displays the header of the menu preview.

import { DefaultButton, PrimaryButton, Stack, Text } from "@fluentui/react";
import classNames from "classnames";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MenuPublishedState, StationEditState } from "../../common/commonConstants";
import { confirmDeleteMenu, confirmPublishMenu } from "../../reducers/diningReducer";
import { weekMenuSelector } from "../../selectors/diningSelector";
import styles from "../../styles/menuPreview.module.css";

export interface MenuPreviewHeaderProps {
  cafeName: string;
  serviceHours?: string;
  notificationState: MenuPublishedState | StationEditState | undefined;
}

const MenuPreviewHeaderView = ({ cafeName, serviceHours, notificationState }: MenuPreviewHeaderProps) => {
  const dispatch = useDispatch();
  const weeklyMenu = useSelector(weekMenuSelector);

  return (
    <Stack className={styles.menuPreviewHeader}>
      <Stack
        className={styles.menuPreviewHeader}
        horizontal
        horizontalAlign={"space-between"}
        verticalAlign="center"
        tokens={{ childrenGap: 20 }}
        wrap={true}
      >
        <h1 className={classNames("ms-fontSize-32")}>{cafeName}</h1>
        <Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 10 }} wrap={true}>
          <PrimaryButton
            text={"Publish"}
            onClick={() => dispatch(confirmPublishMenu())}
            disabled={notificationState === MenuPublishedState.CHANGES_PUBLISHED_SUCCESSFULLY || !weeklyMenu}
          />
          <DefaultButton
            text={"Delete"}
            onClick={() => dispatch(confirmDeleteMenu())}
            disabled={notificationState === MenuPublishedState.CHANGES_PUBLISHED_SUCCESSFULLY || !weeklyMenu}
          />
        </Stack>
      </Stack>
      {serviceHours && <Text className={styles.serviceHours}>{serviceHours}</Text>}
    </Stack>
  );
};

export default MenuPreviewHeaderView;
